import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ReservationService } from 'src/app/services/reservation.service';
import { DateService } from 'src/app/services/date.service';
import { PrimeNG } from 'primeng/config';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'rqa-select-date-dialog',
  templateUrl: './select-date-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    ButtonModule,
    TranslateModule,
    DatePickerModule
  ]
})
export class SelectDateDialogComponent implements OnInit {
  private ref = inject(DynamicDialogRef);
  private reservationService = inject(ReservationService);
  private dateService = inject(DateService);
  private translateService = inject(TranslateService);
  private primengConfig = inject(PrimeNG);
  dialogConfig = inject(DynamicDialogConfig);
  date: Date;
  minDate: Date;
  maxDate: Date;

  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.translateService.get('primeng').subscribe((res: any) => this.primengConfig.setTranslation(res));
    this.getReservableInterval();
  }

  save(): void {
    this.ref.close(this.date);
  }

  close(): void {
    this.ref.close();
  }

  private getReservableInterval() {
    const commonInterval = this.reservationService.commonDateInterval();
    if (commonInterval) {
      this.minDate = this.dateService.parseIsoDateToDateObj(commonInterval.startDate);
      this.maxDate = this.dateService.parseIsoDateToDateObj(commonInterval.endDate);
      this.date = this.minDate;
    }
  }
}
